import { Handle, type Node, type NodeProps, Position } from "@xyflow/react";

import type { DipGroupNodeData } from "~/features/dataImportProjects/types";
import { cn } from "~/lib/utils";

export function DipGroupNode({ data }: NodeProps<Node<DipGroupNodeData>>) {
  const showHandles = data.showHandles ?? true;
  const clickable = (typeof data.detailPath === "string" && data.detailPath.length > 0) || data.peek != null;
  const handleClassName = cn("!h-2 !w-2 !border-none !bg-primary-300", !showHandles && "!opacity-0");

  return (
    <>
      <Handle type="target" position={Position.Left} className={handleClassName} />
      <div
        className={cn(
          "flex h-full w-full flex-col rounded-[var(--radius-md)] border border-border-strong bg-bg-subtle px-3 py-2.5 shadow-none transition-colors",
          clickable && "cursor-pointer hover:border-primary-500 hover:bg-primary-50",
        )}
      >
        <strong className="line-clamp-2 h-9 overflow-hidden text-14-bold leading-[18px] text-fg-1">{data.label}</strong>
      </div>
      <Handle type="source" position={Position.Right} className={handleClassName} />
    </>
  );
}
